import { render, staticRenderFns } from "./VoteRanking.vue?vue&type=template&id=26e8be8a&scoped=true"
import script from "./VoteRanking.vue?vue&type=script&lang=js"
export * from "./VoteRanking.vue?vue&type=script&lang=js"
import style0 from "./VoteRanking.vue?vue&type=style&index=0&id=26e8be8a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26e8be8a",
  null
  
)

export default component.exports